<template>
  <div class="accessory_orders">
    <b-container fluid>
      <h1>Accessory Orders</h1>
      <b-row class="print-hidden">
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-button class="print-hidden" variant="primary" @click="showModal('modal-add-accessory-order')">Add</b-button>
      
      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="fields"
        :filter="filterCriteria"
        :filter-included-fields="filter_on"
        :items="displayed_items"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >

        <template #cell(ordered_date)="row">
          <div>{{formatDate(row.item.ordered_date)}}</div>
        </template>

        <template #cell(received_date)="row">
          {{formatDate(row.item.received_date)}}
        </template>

        <template #cell(description)="row">
          <p style="width: 440px" v-for="(_item, index) in row.item.items" :key="row.item.invoice_number + '-table-item-' + index">
            <strong>{{_item.item_name}}:</strong>
            {{' Type: ' + _item.item_type + ', Quantity: ' + _item.item_quantity
              + (row.item.type == "Door"?
              ', ' + _item.door_size
              + ', ' + _item.door_frame_color
              + ', ' + _item.door_perspex_color : "")}}
          </p>
        </template>
        
        <template #cell(is_standard)="row">
          <span v-if="row.item.place">YES</span>
          <span v-if="!row.item.place">NO</span>
        </template>

      </b-table>

      <!-- ADD ITEM -->
      <b-modal size="lg" id="modal-add-accessory-order" hide-footer title="Add Accessory Order">
        <b-form @submit.prevent="add_accessory_order">
          <b-row>
            <b-col cols="6">
              <label for="invoice_number">Invoice #:</label>
              <b-input type="text" 
                id="invoice_number" 
                v-model="new_accessory_order.invoice_number"
                required></b-input>
            </b-col>
            <b-col cols="6">
              <label for="sales_name">Sales:</label>
              <b-form-select
                id="sales_name"
                v-model="new_accessory_order.sales_name"
                :options="sales_names"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <label for="ordered_date">Ordered date:</label>
              <b-form-datepicker type="text"
                id="ordered_date"
                v-model="new_accessory_order.ordered_date"
                class="form-control"
                required></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label for="ordered_date">Received date:</label>
              <b-form-datepicker type="text"
                id="received_date"
                v-model="new_accessory_order.received_date"
                class="form-control"></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label for="item_supplier">Supplier:</label>
              <b-form-select
                id="type"
                v-model="new_accessory_order.supplier_name"
                :options="supplier_names"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <label for="store_location">Store Location:</label>
              <b-form-select
                id="type"
                v-model="new_accessory_order.store_location"
                :options="store_locations"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="12">
              <!-- <b-button class="mt-2" variant="primary" @click="addAnItemToNew()">Add an item</b-button> -->
              <b-dropdown class="mt-2" variant="primary" text="Add an item">
                <b-dropdown-item @click="addGeneralItemToNew('Cross')">Cross</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToNew('Decoration')">Decoration</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToNew('Lantern')">Lantern</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToNew('Photo Frame')">Photo Frame</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addDoorToNew()">Door</b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
          <b-row align-v="center" class="rounded my-1 p-1" v-for="(item, index) in new_accessory_order.items" :key="item.invoice_number + '-item-' + index">
            <b-col cols="6">
              <label for="type">Type:</label>
              <p>{{item.item_type}}</p>
            </b-col>
            <b-col cols="5">
              <label for="item_code">Name:</label>
              <!-- <b-input type="text" 
                id="item_code" 
                v-model="item.item_code" 
                required></b-input> -->
              <b-form-select
                v-if="item.item_type == 'Cross'"
                id="item_name" 
                v-model="item.item_name" 
                :options="inven_cross_names"
                required></b-form-select>
              <b-form-select
                v-if="item.item_type == 'Door'"
                id="item_name" 
                v-model="item.item_name" 
                :options="inven_door_names"
                required></b-form-select>
              <b-form-select
                v-if="item.item_type == 'Decoration'"
                id="item_name" 
                v-model="item.item_name" 
                :options="inven_decoration_names"
                required></b-form-select>
              <b-form-select
                v-if="item.item_type == 'Lantern'"
                id="item_name" 
                v-model="item.item_name" 
                :options="inven_lantern_names"
                required></b-form-select>
              <b-form-select
                v-if="item.item_type == 'Photo Frame'"
                id="item_name" 
                v-model="item.item_name" 
                :options="inven_photo_frame_names"
                required></b-form-select>
            </b-col>
            <b-col cols="6">
              <label for="item_description">Item Description:</label>
              <b-input type="text" 
                id="item_description" 
                v-model="item.item_description" 
                ></b-input>
            </b-col>
            <b-col v-if="item.item_type == 'Door'" cols="6">
              <label for="door_size">Door Size:</label>
              <b-input type="text" 
                id="door_size" 
                v-model="item.door_size" 
                ></b-input>
            </b-col>
            <b-col v-if="item.item_type == 'Door'" cols="6">
              <label for="door_frame_color">Door frame color:</label>
              <b-input type="text" 
                id="door_frame_color" 
                v-model="item.door_frame_color" 
                ></b-input>
            </b-col>
            <b-col v-if="item.item_type == 'Door'" cols="6">
              <label for="door_perspex_color">Door perspex color:</label>
              <b-input type="text" 
                id="door_perspex_color" 
                v-model="item.door_perspex_color" 
                ></b-input>
            </b-col>
            <b-col cols="6">
              <label for="item_quantity">Quantity:</label>
              <b-input type="number" 
                id="item_quantity" 
                v-model="item.item_quantity"
                required></b-input>
            </b-col>
            <b-col cols="6">
              <b-button variant="danger" class="mt-2 mb-0" @click="removeItemFromNew(index)">Remove</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Standard?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-standard"
                  v-model="new_accessory_order.is_standard"
                  :aria-describedby="ariaDescribedby"
                  name="radio-group-is-standard"
                  required
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Re-ordered?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-reordered"
                  v-model="new_accessory_order.is_reordered"
                  :aria-describedby="ariaDescribedby"
                  name="radio-group-is-reordered"
                  required
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <label for="comment">Reordered reason:</label>
              <b-input type="text"
                :disabled="new_accessory_order.is_reordered != true"
                id="comment" 
                v-model="new_accessory_order.reordered_reason" 
                required></b-input>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Pick up?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-pick-up"
                  v-model="new_accessory_order.is_pickup"
                  :aria-describedby="ariaDescribedby"
                  name="radio-group-is-pick-up"
                  required
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <label for="post_to">Post to:</label>
              <b-input type="text" 
                id="post_to" 
                :disabled="new_accessory_order.is_pickup != false"
                v-model="new_accessory_order.post_to"
                required>
              </b-input>
            </b-col>
            <b-col cols="12">
              <label for="place">Place:</label>
              <b-form-select
                id="sales_name"
                v-model="new_accessory_order.place"
                :options="places"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="12">
              <label for="comment">Comment:</label>
              <b-textarea type="text" 
                id="comment" 
                v-model="new_accessory_order.comment" 
                rows="2"></b-textarea>
            </b-col>
          </b-row>

          <!-- <label for="item_description">Description:</label>
          <b-input type="text" 
            id="item_description" 
            v-model="new_accessory_order.item_description" 
            required></b-input> -->

          <div class="modal-footer mt-4">
            <b-button @click="hideModal('modal-add-accessory-order')"> Cancel </b-button>
            <b-button type="submit" variant="primary">
              <span v-if="!is_submitting">Submit</span>
              <span v-if="is_submitting">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- VIEW ITEM -->
      <b-modal size="lg" id="modal-view-accessory-order" hide-header hide-footer title="View Accessory Order">
        <b-form @submit.prevent="update_accessory_order">
          <div>
            <h5>View Accessory Order <b-button class="ml-2" variant="primary" size="sm" @click="print()">Print</b-button></h5>
            <hr>
          </div>
          <b-row>
            <b-col cols="6">
              <label for="invoice_number">Invoice #:</label>
              <b-input type="text" 
                id="invoice_number" 
                v-model="viewed_accessory_order.invoice_number"
                required></b-input>
            </b-col>
            <b-col cols="6">
              <label for="sales_name">Sales:</label>
              <b-form-select
                id="sales_name"
                v-model="viewed_accessory_order.sales_name"
                :options="sales_names"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <label for="ordered_date">Ordered date:</label>
              <b-form-datepicker type="text"
                id="ordered_date"
                v-model="viewed_accessory_order.ordered_date"
                class="form-control"
                required></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label for="ordered_date">Received date:</label>
              <b-form-datepicker type="text"
                id="received_date"
                v-model="viewed_accessory_order.received_date"
                class="form-control"></b-form-datepicker>
            </b-col>
            <b-col cols="6">
              <label for="item_supplier">Supplier:</label>
              <b-form-select
                id="type"
                v-model="viewed_accessory_order.supplier_name"
                :options="supplier_names"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="6">
              <label for="store_location">Store Location:</label>
              <b-form-select
                id="type"
                v-model="viewed_accessory_order.store_location"
                :options="store_locations"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="12">
              <b-dropdown class="mt-2" variant="primary" text="Add an item">
                <b-dropdown-item @click="addGeneralItemToViewed('Cross')">Cross</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToViewed('Decoration')">Decoration</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToViewed('Lantern')">Lantern</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addGeneralItemToViewed('Photo Frame')">Photo Frame</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item @click="addDoorToViewed()">Door</b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>
          <b-row class="rounded my-1 p-1" v-for="(item, index) in viewed_accessory_order.items" :key="item.invoice_number + '-item-' + index">
            <b-col cols="6">
              <label for="type">Type: {{item.item_type}}</label>
            </b-col>
            <b-col cols="6">
              <label for="item_name">Item Name: {{item.item_name}}</label>
              <!-- <b-input type="text" 
                id="item_code" 
                v-model="item.item_name" 
                required></b-input> -->
            </b-col>
            <b-col v-if="item.item_description.length > 0" cols="6">
              <label for="item_description">Item Description: {{item.item_description}}</label>
              <!-- <b-input type="text" 
                id="item_description" 
                v-model="item.item_description" 
                required></b-input> -->
            </b-col>
            <b-col v-if="item.type == 'Door'" cols="6">
              <label for="door_size">Door Size: {{item.door_size}}</label>
              <!-- <b-input type="text" 
                id="door_size" 
                v-model="item.door_size" 
                required></b-input> -->
            </b-col>
            <b-col v-if="item.type == 'Door'" cols="6">
              <label for="door_frame_color">Door frame color: {{item.door_frame_color}}</label>
              <!-- <b-input type="text" 
                id="door_frame_color" 
                v-model="item.door_frame_color" 
                required></b-input> -->
            </b-col>
            <b-col v-if="item.type == 'Door'" cols="6">
              <label for="door_perspex_color">Door perspex color: {{item.door_perspex_color}}</label>
              <!-- <b-input type="text" 
                id="door_perspex_color" 
                v-model="item.door_perspex_color" 
                required></b-input> -->
            </b-col>
            <b-col cols="6">
              <label for="item_quantity">Quantity: {{item.item_quantity}}</label>
              <!-- <b-input type="number" 
                id="item_quantity" 
                v-model="item.item_quantity"
                required></b-input> -->
            </b-col>
            <!-- <b-col cols="12">
              <b-button variant="danger" class="mt-2 mb-0" @click="removeItemFromViewd(index)">Remove</b-button>
              <hr>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Standard?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-standard"
                  v-model="viewed_accessory_order.is_standard"
                  :aria-describedby="ariaDescribedby"
                  name="radio-sub-component"
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Re-ordered?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-reordered"
                  v-model="viewed_accessory_order.is_reordered"
                  :aria-describedby="ariaDescribedby"
                  name="radio-group-is-reordered"
                  required
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col v-if="viewed_accessory_order.is_reordered == true" cols="12">
              <label for="comment">Reordered reason:</label>
              <b-input type="text" 
                id="comment"
                :disabled="viewed_accessory_order.is_reordered != true"
                v-model="viewed_accessory_order.reordered_reason" 
                required></b-input>
            </b-col>
            <b-col cols="12">
              <b-form-group label="Pick up?" v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  id="radio-group-is-pick-up"
                  v-model="viewed_accessory_order.is_pickup"
                  :aria-describedby="ariaDescribedby"
                  name="radio-group-is-pick-up"
                  required
                >
                  <b-form-radio :value="true">Yes</b-form-radio>
                  <b-form-radio :value="false">No</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <label for="post_to">Post to:</label>
              <b-input type="text" 
                id="post_to" 
                :disabled="viewed_accessory_order.is_pickup != false"
                v-model="viewed_accessory_order.post_to"
                required>
              </b-input>
            </b-col>
            <b-col cols="12">
              <label for="place">Place:</label>
              <b-form-select
                id="sales_name"
                v-model="viewed_accessory_order.place"
                :options="places"
                required
              ></b-form-select>
            </b-col>
            <b-col cols="12">
              <label for="comment">Comment:</label>
              <b-textarea type="text" 
                id="comment" 
                v-model="viewed_accessory_order.comment" 
                rows="2"></b-textarea>
            </b-col>
          </b-row>

          <div class="modal-footer mt-4">
            <b-button v-if="viewed_accessory_order.status == 'pending'" @click="approve_order" variant="warning">Approve</b-button>
            <b-button @click="showModal('modal-delete-confirmation')" variant="danger">Delete</b-button>
            <b-button @click="hideModal('modal-view-accessory-order')"> Cancel </b-button>
            <b-button @click="update_accessory_order" variant="warning">
              <span v-if="!is_updating">Update</span>
              <span v-if="is_updating">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- DELETE CONFIRMATION -->
      <b-modal
        id="modal-delete-confirmation"
        title="Delete confirmation"
        hide-footer
      >
        <p>This operation will delete a record.</p>
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-delete-confirmation')"
          >
            Cancel
          </b-button>
          <b-button
            :disabled="is_deleting"
            variant="danger"
            @click="delete_record()"
          >
            <span v-if="!is_deleting">Delete</span>
            <span v-if="is_deleting">
              <b-spinner small type="grow"></b-spinner>
              Deleting...
            </span>
          </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  props: {
    user: Object,
  },
  data() {
    return {
      inven_cross_names: [],
      inven_door_names: [],
      inven_decoration_names: [],
      inven_lantern_names: [],
      inven_photo_frame_names: [],
      inven_items: [],
      fields: [
        { key: 'invoice_number', label: 'Invoice #'},
        { key: 'sales_name', label: 'Sales'},
        { key: 'ordered_date', label: 'Ordered Date'},
        { key: 'received_date', label: 'Received Date'},
        { key: 'description', label: 'Description'},
        // { key: 'type', label: 'Type'},
        // { key: 'item_code', label: 'Item Code'},
        // { key: 'item_description', label: 'Description'},
        // { key: 'item_quantity', label: 'QTY'},
        { key: 'supplier_name', label: 'Supplier'},
        { key: 'is_standard', label: 'Standard?'},
        { key: 'place', label: 'Place'},
        { key: 'status', label: 'Status'},
      ],
      filter_on: [
        "invoice_number",
        "sales_name",
        'ordered_date',
        'received_date',
        'supplier_name',
        'description',
        'supplier_name',
        'is_standard',
        'place',
        'status',
      ],
      filterCriteria: "",
      displayed_items: [],
      items: [],
      perPage: 20,
      currentPage: 1,
      tableIsBusy: false,
      new_accessory_order: {
        stock_out_records: [],
        id: "",
        invoice_number: "",
        sales_name: "",
        items: [],
        // type: '',
        // item_code: '',
        // item_description: "",
        // item_quantity: 0,
        supplier_name: '',
        supplier: '',
        ordered_date: "",
        received_date: "",
        is_standard: Boolean,
        is_reordered: Boolean,
        is_pickup: Boolean,
        // door_size: '',
        // door_frame_color: '',
        // door_perspex_color: '',
        post_to: "",
        place: "",
        comment: "",
        status: "",
        store_location: "",
      },
      viewed_accessory_order: {
        stock_out_records: [],
        id: "",
        invoice_number: "",
        sales_name: "",
        items: [],
        supplier_name: '',
        supplier: '',
        ordered_date: "",
        received_date: "",
        is_standard: Boolean,
        is_reordered: Boolean,
        is_pickup: Boolean,
        post_to: "",
        place: "",
        comment: "",
        status: "",
        store_location: "",
      },
      sales: [],
      sales_names: [],
      suppliers: [],
      supplier_names: [],
      is_submitting: false,
      is_updating: false,
      is_deleting: false,
      accessory_types: ['Cross', 'Door', 'Decoration', 'Lantern', 'Photo Frame'],
      filterOn: [
        "invoice_number",
        "sales_name",
        "ordered_date",
        "received_date",
        "type",
        "item_description",
        "item_quantity",
        "supplier",
        "is_standard",
        "place",
        "comment",
      ],
      places: ['Dandenong', 'Thomastown'],
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      store_locations: [],
    };
  },
  methods: {
    print() {
      this.$emit("exportAccessoryOrder", this.viewed_accessory_order);
    },
    formatDate(dateString) {
      if (!dateString || dateString == "") return "";
      const ymd = dateString.split("-");
      const monthString = ymd[1].charAt(0) == "0" ? ymd[1].slice(1) : ymd[1];
      return ymd[2] + "-" + this.monthNames[parseInt(monthString) - 1];
    },
    addGeneralItemToViewed(type) {
      this.viewed_accessory_order.items.unshift({
        item_type: type,
        item_code: '',
        item_description: '',
        item_quantity: '',
      });
    },
    addDoorToViewed() {
      this.viewed_accessory_order.items.unshift({
        item_type: 'Door',
        item_code: '',
        item_description: '',
        item_quantity: '',
        door_size: '',
        door_fradoor_frame_colorme_color: '',
        door_perspex_color: '',
      });
    },
    removeItemFromViewed(index) {
      this.viewed_accessory_order.items.splice(index, 1);
    },
    addGeneralItemToNew(type) {
      this.new_accessory_order.items.unshift({
        item_type: type,
        item_code: '',
        item_description: '',
        item_quantity: '',
        door_size: '',
        door_fradoor_frame_colosrme_color: '',
        door_perspex_color: '',
      });
    },
    addDoorToNew() {
      this.new_accessory_order.items.unshift({
        item_type: 'Door',
        item_code: '',
        item_description: '',
        item_quantity: '',
        door_size: '',
        door_fradoor_frame_colorme_color: '',
        door_perspex_color: '',
      });
    },
    removeItemFromNew(index) {
      this.new_accessory_order.items.splice(index, 1);
    },
    removeItemFromViewd(index) {
      this.viewed_accessory_order.items.splice(index, 1);
    },
    approve_order() {
      this.viewed_accessory_order.status = 'sent';
      firebase.firestore().collection("accessory_orders").doc(this.viewed_accessory_order.id).set({status: 'sent'}, { merge: true});
    
      // var email_text = 
      //   'Invoice Number: ' + this.viewed_accessory_order.invoice_number +
      //   '\nSupplier: ' + this.viewed_accessory_order.supplier_name +
      //   '\nOrdered Date: ' + this.viewed_accessory_order.created_date +
      //   '\nSender: ' + this.user.name +
      //   '\nType: ' + this.viewed_accessory_order.type +
      //   '\nItem Code: ' + this.viewed_accessory_order.item_code +
      //   '\nQuantity: ' + this.viewed_accessory_order.item_quantity
      // if(this.viewed_accessory_order.type == 'Door') {
      //   email_text += '\nDoor Size: ' + this.viewed_accessory_order.door_size +
      //     '\nDoor Frame Color: ' + this.viewed_accessory_order.door_frame_color +
      //     '\nDoor Perspex Color: ' + this.viewed_accessory_order.door_perspex_color
      // }
      // if(this.viewed_accessory_order.is_reordered) {
      //   email_text += '\nRe-order?: ' + 'Yes'
      //     '\nRe-order Reason: ' + this.viewed_accessory_order.reordered_reason;
      // } else {
      //   email_text += '\nRe-order?: ' + 'No';
      // }
      // if(this.viewed_accessory_order.is_pickup) {
      //   email_text += '\nPick Up?: ' + 'Yes';
      // } else {
      //   email_text += '\nPick Up?: ' + 'No'
      //     + '\nPost To: ' + this.viewed_accessory_order.post_to;
      // } 
      // email_text += '\nComment: ' + this.viewed_accessory_order.comment;

      // var email = {
      //   from: this.user.email,
      //   to: [this.viewed_accessory_order.supplier.email],
      //   message: {
      //     subject: this.viewed_accessory_order.invoice_number + " - Purchase Order",
      //     text: email_text
      //   },
      // };

      // firebase
      //   .firestore()
      //   .collection("mail")
      //   .add(email);
    },
    myRowClickHandler(item) {
      console.log(item);
      this.viewed_accessory_order = Object.assign({}, item);
      this.showModal('modal-view-accessory-order');
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      this.new_accessory_order.ordered_date = this.today;
    },
    initial_global_variables() {
      this.new_accessory_order.sales_name = this.user.name;
    },
    add_accessory_order() {
      for (let i = 0; i < this.new_accessory_order.items.length; i++) {
        let item = this.new_accessory_order.items[i];
        if (parseInt(this.inven_items[item.item_name].item_number_in_stock) < parseInt(item.item_quantity)) {
          alert(item.item_name + ' not enough. Available ' + item.item_name + ': ' + this.inven_items[item.item_name].item_number_in_stock);
          return;
        }
      }

      for (let i = 0; i < this.new_accessory_order.items.length; i++) {
        const new_stock_out_ref = firebase.firestore().collection('stock_out_records').doc();
        let item = this.new_accessory_order.items[i];
        let new_stock_out = {
          id: new_stock_out_ref.id,
          invoice_number: this.new_accessory_order.invoice_number,
          creator: this.user,
          creator_name: this.user.name,
          item_type: item.item_type,
          item_name: item.item_name,
          item_quantity: item.item_quantity,
          date: this.today,
          is_standard: true,
          status: "",
          comment: item.item_description,
          year_month: this.today.substring(0, 7),
          day: parseInt(this.today.substring(8, 10)),
        }
        this.new_accessory_order.stock_out_records.push(new_stock_out);

        firebase.firestore().collection("inventory").where('item_name', '==', item.item_name).get().then((collection) => {
          var exisiting_items = collection.docs.map(doc => doc.data());
          if (exisiting_items.length > 0) {
            exisiting_items.forEach((element) => {
              element.item_number_in_stock = 0 - parseInt(new_stock_out.item_quantity) + parseInt(element.item_number_in_stock);
              if (element.item_number_in_stock >= 0) {
                const element_ref = firebase.firestore().collection('inventory').doc(element.id);
                element_ref.set(element, { merge: true });
                this.is_submitting = true;
                new_stock_out_ref.set(new_stock_out, { merge: true });
              } else {
                alert('No enough items');
              }
            });
          }
        });
      }

      this.is_submitting = true;
      const new_accessory_order_ref = firebase.firestore().collection('accessory_orders').doc();

      this.new_accessory_order.id = new_accessory_order_ref.id;
      this.new_accessory_order.created_date = this.today;
      this.new_accessory_order.year_month = this.new_accessory_order.created_date.substring(
        0,
        7
      );
      this.new_accessory_order.day = parseInt(
        this.new_accessory_order.created_date.substring(8, 10)
      );
      this.new_accessory_order.created_by = this.user;
      this.new_accessory_order.created_by_name = this.user.name;
      this.new_accessory_order.sales = this.sales[
        this.sales_names.indexOf(this.new_accessory_order.sales_name)
      ];
      this.new_accessory_order.supplier = this.suppliers[
        this.supplier_names.indexOf(this.new_accessory_order.supplier_name)
      ];
      if(this.new_accessory_order.is_standard) this.new_accessory_order.status = 'sent';
      else this.new_accessory_order.status = 'pending';

      firebase.firestore().collection("follow_up_reports").where('invoice_number', '==', this.new_accessory_order.invoice_number).get().then((collection) => {
        collection.docs.map(doc => doc.data()).forEach((data) => {
          switch(this.new_accessory_order.type) {
            case 'Cross':
              data.accessory.cross.cross_dates[0].date = this.new_accessory_order.ordered_date;
              data.accessory.cross.cross_dates[1].date = this.new_accessory_order.received_date;
              break;
            case 'Door':
              data.accessory.door.door_dates[0].date = this.new_accessory_order.ordered_date;
              data.accessory.door.door_dates[1].date = this.new_accessory_order.received_date;
              break;
            case 'Decoration':
              data.accessory.decoration.decoration_dates[0].date = this.new_accessory_order.ordered_date;
              data.accessory.decoration.decoration_dates[1].date = this.new_accessory_order.received_date;
              break;
            case 'Lantern':
              data.accessory.lantern.lantern_dates[0].date = this.new_accessory_order.ordered_date;
              data.accessory.lantern.lantern_dates[1].date = this.new_accessory_order.received_date;
              break;
            case 'Photo Frame':
              data.accessory.photo_frame.photo_frame_dates[0].date = this.new_accessory_order.ordered_date;
              data.accessory.photo_frame.photo_frame_dates[1].date = this.new_accessory_order.received_date;
              break;
          }
          console.log(data);
          firebase.firestore().collection("follow_up_reports").doc(data.id).set(data, { merge: true});
        });
      });

      new_accessory_order_ref
        .set(this.new_accessory_order, { merge: true }).then(() => {
          const notification_email = {
            from: 'info@johnstonemart.com',
            to: ['rick@johnstonemart.com'],
            message: {
              subject: "An accessory order has been placed - " + this.new_accessory_order.invoice_number,
              text: 'Invoice Number: ' + this.new_accessory_order.invoice_number +
                '\nSupplier: ' + this.new_accessory_order.supplier_name +
                '\nOrdered Date: ' + this.new_accessory_order.created_date +
                '\nSender: ' + this.user.name
            },
          };

            firebase
              .firestore()
              .collection("mail")
              .add(notification_email);

          // var email = {};
          // var email_text = 
          //   'Invoice Number: ' + this.new_accessory_order.invoice_number +
          //   '\nSupplier: ' + this.new_accessory_order.supplier_name +
          //   '\nOrdered Date: ' + this.new_accessory_order.created_date +
          //   '\nSender: ' + this.user.name +
          //   '\nType: ' + this.new_accessory_order.type +
          //   '\nItem Code: ' + this.new_accessory_order.item_code +
          //   '\nQuantity: ' + this.new_accessory_order.item_quantity
          // if(this.new_accessory_order.type == 'Door') {
          //   email_text += '\nDoor Size: ' + this.new_accessory_order.door_size +
          //     '\nDoor Frame Color: ' + this.new_accessory_order.door_frame_color +
          //     '\nDoor Perspex Color: ' + this.new_accessory_order.door_perspex_color
          // }
          // if(this.new_accessory_order.is_reordered) {
          //   email_text += '\nRe-order?: ' + 'Yes'
          //     '\nRe-order Reason: ' + this.new_accessory_order.reordered_reason;
          // } else {
          //   email_text += '\nRe-order?: ' + 'No';
          // }
          // if(this.new_accessory_order.is_pickup) {
          //   email_text += '\nPick Up?: ' + 'Yes';
          // } else {
          //   email_text += '\nPick Up?: ' + 'No'
          //     + '\nPost To: ' + this.new_accessory_order.post_to;
          // } 
          // email_text += '\nComment: ' + this.new_accessory_order.comment;

          // if (this.new_accessory_order.status == 'sent') {
          //   email = {
          //     from: this.user.email,
          //     to: [this.new_accessory_order.supplier.email],
          //     message: {
          //       subject: this.new_accessory_order.invoice_number + " - Purchase Order",
          //       text: email_text
          //     },
          //   };

          //   firebase
          //     .firestore()
          //     .collection("mail")
          //     .add(email);
          // } else {
          //   email = {
          //     from: this.user.email,
          //     to: ['jacky@johnstonemart.com'],
          //     message: {
          //       subject: this.new_accessory_order.invoice_number + " - an accessory order is pending",
          //       text: email_text
          //     },
          //   };

          //   firebase
          //     .firestore()
          //     .collection("mail")
          //     .add(email);
          // }

          this.is_submitting = false;
          this.new_accessory_order = {
            stock_out_records: [],
            id: "",
            invoice_number: "",
            sales_name: "",
            items: [],
            supplier_name: '',
            supplier: '',
            ordered_date: "",
            received_date: "",
            is_standard: Boolean,
            is_reordered: Boolean,
            is_pickup: Boolean,
            post_to: "",
            place: "",
            comment: "",
            status: "",
            store_location: "",
          };
          alert('Create successfully.');
          this.hideModal('modal-add-accessory-order');
        });
    },
    update_accessory_order() {
      this.is_updating = true;
      firebase
        .firestore()
        .collection("accessory_orders")
        .doc(this.viewed_accessory_order.id)
        .set(this.viewed_accessory_order, { merge: true })
        .then(() => {
          alert("Modify successfully");

          this.viewed_accessory_order.sales = this.sales[
            this.sales_names.indexOf(this.viewed_accessory_order.sales_name)
          ];
          this.viewed_accessory_order.supplier = this.suppliers[
            this.supplier_names.indexOf(this.viewed_accessory_order.supplier_name)
          ];

          firebase.firestore().collection("follow_up_reports").where('invoice_number', '==', this.viewed_accessory_order.invoice_number).get().then((collection) => {
            collection.docs.map(doc => doc.data()).forEach((data) => {
              switch(this.viewed_accessory_order.type) {
                case 'Cross':
                  data.accessory.cross.cross_dates[0].date = this.viewed_accessory_order.ordered_date;
                  data.accessory.cross.cross_dates[1].date = this.viewed_accessory_order.received_date;
                  break;
                case 'Door':
                  data.accessory.door.door_dates[0].date = this.viewed_accessory_order.ordered_date;
                  data.accessory.door.door_dates[1].date = this.viewed_accessory_order.received_date;
                  break;
                case 'Decoration':
                  data.accessory.decoration.decoration_dates[0].date = this.viewed_accessory_order.ordered_date;
                  data.accessory.decoration.decoration_dates[1].date = this.viewed_accessory_order.received_date;
                  break;
                case 'Lantern':
                  data.accessory.lantern.lantern_dates[0].date = this.viewed_accessory_order.ordered_date;
                  data.accessory.lantern.lantern_dates[1].date = this.viewed_accessory_order.received_date;
                  break;
                case 'Photo Frame':
                  data.accessory.photo_frame.photo_frame_dates[0].date = this.viewed_accessory_order.ordered_date;
                  data.accessory.photo_frame.photo_frame_dates[1].date = this.viewed_accessory_order.received_date;
                  break;
              }
              firebase.firestore().collection("follow_up_reports").doc(data.id).set(data, { merge: true});
            });
          });

          this.is_updating = false;
        });
    },
    delete_record() {
      this.is_deleting = true;
      firebase
        .firestore()
        .collection("accessory_orders")
        .doc(this.viewed_accessory_order.id)
        .delete().then(() => {
          alert('Delete successfully.');
          this.is_deleting = false;
          this.hideModal('modal-view-accessory-order');
          this.hideModal('modal-delete-confirmation');
        });
    },
  },
  created() {
    this.set_global_date();

    firebase
      .firestore()
      .collection("store_locations")
      .orderBy("name", "asc")
      .onSnapshot((collection) => {
        var rows = collection.docs.map((doc) => doc.data());
        console.log(rows);
        for (var i = 0; i < rows.length; i++) {
          this.store_locations.push(rows[i].name);
        }
      });

    firebase
      .firestore()
      .collection("saless")
      .orderBy("name", "asc")
      .onSnapshot((collection) => {
        this.sales = [];
        this.sales_names = [];
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.sales_names.push(this.sales[i].name);
        }
      });

    firebase.firestore().collection('suppliers').orderBy("name", "asc").onSnapshot((collection) => {
      this.suppliers = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.suppliers.length; i++) {
        this.supplier_names.push(this.suppliers[i].name);
      }
    });

    if (this.user.role == "sales") {
      this.initial_global_variables();
      firebase.firestore().collection("accessory_orders").where("follower", "==", this.user.name).orderBy('invoice_number', "desc").onSnapshot((collection) => {
        this.items = [];
        this.items = collection.docs.map(doc => doc.data());
        this.displayed_items = this.items;
      });
    } else {
      firebase.firestore().collection("accessory_orders").orderBy('invoice_number', "desc").onSnapshot((collection) => {
        this.items = [];
        this.items = collection.docs.map(doc => doc.data());
        this.displayed_items = this.items;
      });
    }

    firebase.firestore().collection("inventory").orderBy('item_name', "asc").onSnapshot((collection) => {
      const items = collection.docs.map(doc => doc.data());
      for (var i = 0; i < items.length; i++) {
        if (items[i].item_type == 'Cross') this.inven_cross_names.push(items[i].item_name);
        if (items[i].item_type == 'Door') this.inven_door_names.push(items[i].item_name);
        if (items[i].item_type == 'Decoration') this.inven_decoration_names.push(items[i].item_name);
        if (items[i].item_type == 'Lantern') this.inven_lantern_names.push(items[i].item_name);
        if (items[i].item_type == 'Photo Frame') this.inven_photo_frame_names.push(items[i].item_name);
        this.inven_items[items[i].item_name] = items[i];
      }
    });
  },
}
</script>

<style>
.rounded {
  background-color: pink;
  border: 2px solid gray;
  border-radius: 10px;
}
</style>